import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TextRow = styled.div`
	display: flex;
	justify-content: flex-start;
	gap: 4px;
`;

export const SummaryLink = styled(TextRow)`
	padding-top: 2px;
	padding-bottom: 2px;

	align-items: center;
`;
